"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMyFeaturesResponseDto = instanceOfMyFeaturesResponseDto;
exports.MyFeaturesResponseDtoFromJSON = MyFeaturesResponseDtoFromJSON;
exports.MyFeaturesResponseDtoFromJSONTyped = MyFeaturesResponseDtoFromJSONTyped;
exports.MyFeaturesResponseDtoToJSON = MyFeaturesResponseDtoToJSON;
exports.MyFeaturesResponseDtoToJSONTyped = MyFeaturesResponseDtoToJSONTyped;
var FeatureItemDto_1 = require("./FeatureItemDto");
/**
 * Check if a given object implements the MyFeaturesResponseDto interface.
 */
function instanceOfMyFeaturesResponseDto(value) {
    if (!('planCode' in value) || value['planCode'] === undefined)
        return false;
    if (!('features' in value) || value['features'] === undefined)
        return false;
    return true;
}
function MyFeaturesResponseDtoFromJSON(json) {
    return MyFeaturesResponseDtoFromJSONTyped(json, false);
}
function MyFeaturesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'planCode': json['planCode'],
        'features': (json['features'].map(FeatureItemDto_1.FeatureItemDtoFromJSON)),
    };
}
function MyFeaturesResponseDtoToJSON(json) {
    return MyFeaturesResponseDtoToJSONTyped(json, false);
}
function MyFeaturesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'planCode': value['planCode'],
        'features': (value['features'].map(FeatureItemDto_1.FeatureItemDtoToJSON)),
    };
}
